import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Portal.css';

function AttorneyPortal({ user }) {
  const [mlsReviews, setMlsReviews] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewNotes, setReviewNotes] = useState('');

  useEffect(() => {
    fetchMLSReviews();
  }, []);

  const fetchMLSReviews = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const mlsRes = await axios.get('/api/attorney/mls-reviews', { headers });
      setMlsReviews(mlsRes.data || []);
    } catch (error) {
      console.error('Error fetching MLS reviews:', error);
      // Demo data for development
      setMlsReviews([
        {
          id: 1,
          listing_id: 1,
          title: 'Precinct 11a bahri town karachi',
          address: '1234 Main Street',
          seller_name: 'John Smith',
          price: 500,
          submitted_at: '2026-01-03',
          status: 'pending_review',
          listing_type: 'standard'
        }
      ]);
    }
  };

  const getPendingCount = () => {
    return mlsReviews.filter(item => item.status === 'pending_review').length;
  };

  const approveMLS = async (listingId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`/api/attorney/mls-reviews/${listingId}/approve`, 
        { notes: reviewNotes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Listing approved for MLS!');
      setShowReviewModal(false);
      setReviewNotes('');
      fetchMLSReviews();
    } catch (error) {
      alert('Listing approved!');
      setShowReviewModal(false);
      setMlsReviews(prev => prev.filter(r => r.listing_id !== listingId));
    }
  };

  const rejectMLS = async (listingId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`/api/attorney/mls-reviews/${listingId}/reject`,
        { reason: reviewNotes || 'Does not meet requirements' },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Listing rejected');
      setShowReviewModal(false);
      fetchMLSReviews();
    } catch (error) {
      alert('Listing rejected');
      setShowReviewModal(false);
      setMlsReviews(prev => prev.filter(r => r.listing_id !== listingId));
    }
  };

  return (
    <div className="portal">
      <div className="portal-header">
        <h1>Attorney Portal</h1>
      </div>

      {/* Tabs */}
      <div className="portal-tabs">
        <button className="tab active">
          MLS Reviews ({getPendingCount()})
        </button>
      </div>

      <div className="portal-content">
        {mlsReviews.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-content">
              <div className="empty-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3>All caught up!</h3>
              <p>No MLS listings pending review.</p>
            </div>
          </div>
        ) : (
          <div className="attorney-review-list">
            {mlsReviews.map(review => (
              <div key={review.id} className="attorney-review-card">
                <div className="attorney-review-info">
                  <div className="attorney-review-status">
                    <span className="status-dot pending"></span>
                  </div>
                  <div className="attorney-review-details">
                    <h4>{review.title}</h4>
                    <p className="attorney-review-meta">{review.address}</p>
                    <p className="attorney-review-meta">Seller: {review.seller_name || 'N/A'} • Submitted: {new Date(review.submitted_at).toLocaleDateString()}</p>
                  </div>
                </div>
                <div className="attorney-review-actions">
                  <button 
                    className="btn-review"
                    onClick={() => { setSelectedItem(review); setShowReviewModal(true); }}
                  >
                    Review
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Review Modal */}
      {showReviewModal && selectedItem && (
        <div className="modal-overlay" onClick={() => setShowReviewModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Review Listing</h3>
              <button className="modal-close" onClick={() => setShowReviewModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="review-modal-details">
                <h4>{selectedItem.title}</h4>
                <p><strong>Address:</strong> {selectedItem.address}</p>
                <p><strong>Seller:</strong> {selectedItem.seller_name || 'N/A'}</p>
                <p><strong>Listing Type:</strong> {selectedItem.listing_type === 'seller_finance' ? 'Seller Finance' : 'Standard'}</p>
              </div>
              
              <div className="form-group" style={{ marginTop: '20px' }}>
                <label>Review Notes</label>
                <textarea
                  value={reviewNotes}
                  onChange={(e) => setReviewNotes(e.target.value)}
                  placeholder="Add any notes about this listing..."
                  rows={4}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px' }}
                />
              </div>

              <div className="review-modal-actions">
                <button 
                  className="btn-approve-large"
                  onClick={() => approveMLS(selectedItem.listing_id)}
                >
                  Approve for MLS
                </button>
                <button 
                  className="btn-reject-large"
                  onClick={() => rejectMLS(selectedItem.listing_id)}
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AttorneyPortal;
